<template>
  <div class="activity-wrap">
    <app-header />
    <div class="main-con">
      <div class="inner-con">
        <div class="mod">
          <img src="../../assets/images/activity/activity202107/img1.png" alt="">
          <div class="con">
            <img src="../../assets/images/activity/activity202107/title1.png" alt="">
            <p class="info">海量专业财务数据、编写私密的个性化股票池
策略、专业投资者的不二选择。</p>
            <div class="buy-box">
              <div class="l-con">
                <h3>仅需1876元/年</h3>
                <p>限时抢购7月1日至7月31日</p>
              </div>
              <span class="buy-btn" @click="goUrl(73)">立即购买</span>
            </div>
          </div>
        </div>
        <div class="mod">
          <img src="../../assets/images/activity/activity202107/img2.png" alt="">
          <div class="con">
            <img src="../../assets/images/activity/activity202107/title2.png" alt="">
            <p class="info">包含Level-2全推行情、资金流向、特色指标战法，送100慧豆，还有机会赢取笔记本、小家电等！</p>
            <div class="buy-box">
              <div class="l-con">
                <h3>仅需1元/首月</h3>
                <p>限时抢购6月4日至12月31日</p>
              </div>
              <span class="buy-btn" @click="goOne">立即购买</span>
            </div>
          </div>
        </div>
        <div class="mod">
          <img src="../../assets/images/activity/activity202107/img3.png" alt="">
          <div class="con">
            <img src="../../assets/images/activity/activity202107/title3.png" alt="">
            <p class="info">包含大师特权、道具、专享4大核心功能，智能定制优选策略，驾驭财富梦想。</p>
            <p class="time">限时抢购6月1日至7月31日</p>
            <div class="buy-box">
              <div class="l-con">
                <h3>仅售9800元</h3>
                <p>大智慧财富版<em>年卡</em>+优选大师财富版<em>半年卡</em></p>
              </div>
              <span class="buy-btn" @click="goUrl(126)">立即购买</span>
            </div>
            <div class="buy-box">
              <div class="l-con">
                <h3>仅售16800元</h3>
                <p>大智慧财富版<em>年卡</em>+优选大师财富版<em>年卡</em></p>
              </div>
              <span class="buy-btn" @click="goUrl(197)">立即购买</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tips">
      <div class="tips-con">
        <p>温馨提示：</p>
        <p>大智慧专业版双年卡不参与7折优惠活动，慧豆可在慧信直播节活动中参与抽奖。策略投资终端用户购买优选大师财富版年卡赠送价值9800策略投资终端权限3个月，钜惠大礼包产品包含优选大师财富版权限，价格仍为47800元/年。</p>
      </div>
    </div>
    <div class="tips tips-two">
      <div class="tips-con">
        <p>投资有风险，入市须谨慎。</p>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: ''
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    goUrl (key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month:12}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    },
    goOne () {
      let href = 'https://pay.dzh.com.cn/pay-mall/activity/oyb116?channel=pc_baidu'
      window.open(href, "_blank")
    }
  }
}
</script>
<style lang="scss" scoped>
.activity-wrap{
  background: url(../../assets/images/activity/activity202107/bg1.jpg) no-repeat center 100px,
              url(../../assets/images/activity/activity202107/bg2.jpg) no-repeat center 800px ,
              url(../../assets/images/activity/activity202107/bg3.jpg) no-repeat center 1500px  #7b0000;

  .main-con{
    width: 1200px;
    margin: 970px auto 82px;
    background: linear-gradient(to bottom, #eebf6b, #e0781b, #f0c470);
    padding: 4px;
    border-radius: 20px;
    .inner-con{
      background: #8d0100;
      border-radius: 16px;
      padding-bottom: 30px;
    }
    .mod{
      overflow: hidden;
      padding: 35px 10px;
      &:nth-child(2){
        .con{
          .info{
            margin: 30px 0 45px;
          }
        }
      }
      &:nth-child(3){
        .con{
          .info{
            margin: 15px 0 30px;
          }
        }
        .time{
          font-size: 20px;
          color: #fff;
          margin-bottom: 15px;
        }
      }
      >img{
        display: block;
        width: 369px;
        height: 460px;
        float: left;
      }
      .con{
        float: left;
        margin-left: 50px;
        width: 750px;
        >img{
          display: block;
          margin-top: 15px;
        }
        .info{
          margin: 15px 0 110px;
          font-size: 36px;
          color: #fff;
          line-height: 48px;
          text-align: justify;
        }
        .buy-box{
          background: #bf2f00;
          padding: 20px 28px;
          box-sizing: border-box;
          width: 100%;
          position: relative;
          border-radius: 10px;
          height: 135px;
          +.buy-box{
            margin-top: 30px;
          }
          h3{
            font-size: 36px;
            color: #fff77b;
            margin-bottom: 13px;
            line-height: 1;
            margin-top: 10px;
          }
          p{
            font-size: 20px;
            color: #fff;
            em{
              color: #fff77b;
            }
          }
          .buy-btn{
            display: block;
            width: 240px;
            height: 80px;
            line-height: 80px;
            text-align: center;
            font-size: 36px;
            color: #e60e43;
            position: absolute;
            top: 30px;
            right: 30px;
            background: linear-gradient(to bottom, #fff77b, #ffb21d);
            border-radius: 60px;
            box-sizing: border-box;
            cursor: pointer;
          }
        }
      }
    }
  }
  .tips{
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0 35px;
    background: #670000;
    line-height: 36px;
    .tips-con{
      width: 1100px;
      margin: 0 auto;
    }
    p{
      font-size: 24px;
      color: #fbdfb7;
      text-align: justify;
    }
  }
  .tips-two{
    background: #000000;
    padding: 30px 0;
    p{
      font-size: 24px;
      color: #7c7c7c;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202107.vue